import {USER_TYPE_FILTERS} from './constants';

export const getUserType = store => store.userType.type;
export const getUserDetails = store => store.userType;
export const getUserTouchedFields = store => store.userTouchedFields;
export const getArticlesList = store => store.articles.type;
export const getArticleDetails = store => store.articles.selectedArticle;
export const getDocument = store => store.settings.document; 